/* eslint-disable */
import { initialAbility } from "@/libs/acl/config";
import BaseService from "../../BaseService";

const { http, axios, buildHeaders, buildEndpoint } = BaseService();

// API

export function GetInfoByEmail(data) {
  return http({
    url: "Users/get-by-email/" + data,
    method: "get",
  });
}

export function GetPagingParams(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/get-paging-params-user-is-deleted",
    method: "post",
    data,
  });
}

export function UserCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/Create",
    method: "post",
    data,
  });
}

export function UserUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/Update",
    method: "post",
    data,
  });
}
export function UserUpdateUnitRole(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/update-unitRole",
    method: "post",
    data,
  });
}
export function UserResetPassword(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/reset-password",
    method: "post",
    data,
  });
}

export function UserDelete(postdata) {
  // const data = { ...postdata };
  return http({
    url: "Users/Delete/" + postdata,
    method: "post",
  });
}
export function UserLock(postdata) {
  const data = { ...postdata };
  return http({
    url: "Users/lock-account",
    method: "post",
    data,
  });
}

////////////////////////////////////////////////////////////////////////
